module.exports = function (t) {
  var e = {};

  function i(r) {
    if (e[r]) return e[r].exports;
    var a = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(a.exports, a, a.exports, i), a.l = !0, a.exports;
  }

  return i.m = t, i.c = e, i.d = function (t, e, r) {
    i.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, i.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, i.t = function (t, e) {
    if (1 & e && (t = i(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (i.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var a in t) {
      i.d(r, a, function (e) {
        return t[e];
      }.bind(null, a));
    }
    return r;
  }, i.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return i.d(e, "a", e), e;
  }, i.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, i.p = "", i(i.s = 4);
}([function (t, e) {
  t.exports = require("react");
}, function (t, e, i) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var r,
      a = function () {
    function t(t, e) {
      for (var i = 0; i < e.length; i++) {
        var r = e[i];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, i, r) {
      return i && t(e.prototype, i), r && t(e, r), e;
    };
  }(),
      n = i(0),
      s = (r = n) && r.__esModule ? r : {
    default: r
  };

  var o = function (t) {
    function e(t) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var i = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      return i.canvas = null, i.ctx = null, i.center = null, i.frameId = null, i;
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, n.Component), a(e, [{
      key: "componentDidMount",
      value: function value() {
        this.createCanvas(), this.resize(), this.init(), this.startLoop(), window.addEventListener("resize", this.resize.bind(this));
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        null !== this.frameId && window.cancelAnimationFrame(this.frameId);
      }
    }, {
      key: "init",
      value: function value() {}
    }, {
      key: "draw",
      value: function value() {}
    }, {
      key: "render",
      value: function value() {
        var t = {
          position: "fixed",
          zIndex: -1,
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh"
        };
        return s.default.createElement("div", null, s.default.createElement("canvas", {
          id: "canvasA",
          style: t
        }), s.default.createElement("canvas", {
          id: "canvasB",
          style: t
        }));
      }
    }, {
      key: "createCanvas",
      value: function value() {
        this.canvas = {
          a: document.getElementById("canvasA"),
          b: document.getElementById("canvasB")
        }, this.ctx = {
          a: this.canvas.a.getContext("2d"),
          b: this.canvas.b.getContext("2d")
        }, this.center = [], this.tick = 0;
      }
    }, {
      key: "resize",
      value: function value() {
        var t = window,
            e = t.innerWidth,
            i = t.innerHeight;
        this.canvas.a.width = e, this.canvas.a.height = i, this.ctx.a.drawImage(this.canvas.b, 0, 0), this.canvas.b.width = e, this.canvas.b.height = i, this.ctx.b.drawImage(this.canvas.a, 0, 0), this.center[0] = .5 * this.canvas.a.width, this.center[1] = .5 * this.canvas.a.height;
      }
    }, {
      key: "startLoop",
      value: function value() {
        null == this.frameId && (this.frameId = window.requestAnimationFrame(this.initDraw.bind(this)));
      }
    }, {
      key: "initDraw",
      value: function value() {
        this.draw(), this.frameId = window.requestAnimationFrame(this.initDraw.bind(this));
      }
    }]), e;
  }();

  e.default = o;
}, function (t, e, i) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var r = Math.PI,
      a = (Math.cos, Math.sin, Math.abs),
      n = Math.sqrt,
      s = Math.pow,
      o = (Math.round, Math.random),
      c = Math.atan2,
      l = .5 * r,
      h = 2 * r,
      u = r / 180,
      f = function f(t) {
    return t * o();
  };

  e.HALF_PI = l, e.TAU = h, e.TO_RAD = u, e.floor = function (t) {
    return 0 | t;
  }, e.rand = f, e.randIn = function (t, e) {
    return f(e - t) + t;
  }, e.randRange = function (t) {
    return t - f(2 * t);
  }, e.fadeIn = function (t, e) {
    return t / e;
  }, e.fadeOut = function (t, e) {
    return (e - t) / e;
  }, e.fadeInOut = function (t, e) {
    var i = .5 * e;
    return a((t + i) % e - i) / i;
  }, e.dist = function (t, e, i, r) {
    return n(s(i - t, 2) + s(r - e, 2));
  }, e.angle = function (t, e, i, r) {
    return c(r - e, i - t);
  }, e.lerp = function (t, e, i) {
    return (1 - i) * t + i * e;
  };
}, function (t, e, i) {
  var r;
  !function () {
    "use strict";

    var a = .5 * (Math.sqrt(3) - 1),
        n = (3 - Math.sqrt(3)) / 6,
        s = 1 / 6,
        o = (Math.sqrt(5) - 1) / 4,
        c = (5 - Math.sqrt(5)) / 20;

    function l(t) {
      var e;
      e = "function" == typeof t ? t : t ? function () {
        var t = 0,
            e = 0,
            i = 0,
            r = 1,
            a = (n = 4022871197, function (t) {
          t = t.toString();

          for (var e = 0; e < t.length; e++) {
            var i = .02519603282416938 * (n += t.charCodeAt(e));
            i -= n = i >>> 0, n = (i *= n) >>> 0, n += 4294967296 * (i -= n);
          }

          return 2.3283064365386963e-10 * (n >>> 0);
        });
        var n;
        t = a(" "), e = a(" "), i = a(" ");

        for (var s = 0; s < arguments.length; s++) {
          (t -= a(arguments[s])) < 0 && (t += 1), (e -= a(arguments[s])) < 0 && (e += 1), (i -= a(arguments[s])) < 0 && (i += 1);
        }

        return a = null, function () {
          var a = 2091639 * t + 2.3283064365386963e-10 * r;
          return t = e, e = i, i = a - (r = 0 | a);
        };
      }(t) : Math.random, this.p = h(e), this.perm = new Uint8Array(512), this.permMod12 = new Uint8Array(512);

      for (var i = 0; i < 512; i++) {
        this.perm[i] = this.p[255 & i], this.permMod12[i] = this.perm[i] % 12;
      }
    }

    function h(t) {
      var e,
          i = new Uint8Array(256);

      for (e = 0; e < 256; e++) {
        i[e] = e;
      }

      for (e = 0; e < 255; e++) {
        var r = e + ~~(t() * (256 - e)),
            a = i[e];
        i[e] = i[r], i[r] = a;
      }

      return i;
    }

    l.prototype = {
      grad3: new Float32Array([1, 1, 0, -1, 1, 0, 1, -1, 0, -1, -1, 0, 1, 0, 1, -1, 0, 1, 1, 0, -1, -1, 0, -1, 0, 1, 1, 0, -1, 1, 0, 1, -1, 0, -1, -1]),
      grad4: new Float32Array([0, 1, 1, 1, 0, 1, 1, -1, 0, 1, -1, 1, 0, 1, -1, -1, 0, -1, 1, 1, 0, -1, 1, -1, 0, -1, -1, 1, 0, -1, -1, -1, 1, 0, 1, 1, 1, 0, 1, -1, 1, 0, -1, 1, 1, 0, -1, -1, -1, 0, 1, 1, -1, 0, 1, -1, -1, 0, -1, 1, -1, 0, -1, -1, 1, 1, 0, 1, 1, 1, 0, -1, 1, -1, 0, 1, 1, -1, 0, -1, -1, 1, 0, 1, -1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, -1, 1, 1, 1, 0, 1, 1, -1, 0, 1, -1, 1, 0, 1, -1, -1, 0, -1, 1, 1, 0, -1, 1, -1, 0, -1, -1, 1, 0, -1, -1, -1, 0]),
      noise2D: function noise2D(t, e) {
        var i,
            r,
            s = this.permMod12,
            o = this.perm,
            c = this.grad3,
            l = 0,
            h = 0,
            u = 0,
            f = (t + e) * a,
            p = Math.floor(t + f),
            d = Math.floor(e + f),
            v = (p + d) * n,
            b = t - (p - v),
            y = e - (d - v);
        b > y ? (i = 1, r = 0) : (i = 0, r = 1);

        var P = b - i + n,
            x = y - r + n,
            w = b - 1 + 2 * n,
            g = y - 1 + 2 * n,
            m = 255 & p,
            k = 255 & d,
            _ = .5 - b * b - y * y;

        if (_ >= 0) {
          var O = 3 * s[m + o[k]];
          l = (_ *= _) * _ * (c[O] * b + c[O + 1] * y);
        }

        var M = .5 - P * P - x * x;

        if (M >= 0) {
          var j = 3 * s[m + i + o[k + r]];
          h = (M *= M) * M * (c[j] * P + c[j + 1] * x);
        }

        var C = .5 - w * w - g * g;

        if (C >= 0) {
          var I = 3 * s[m + 1 + o[k + 1]];
          u = (C *= C) * C * (c[I] * w + c[I + 1] * g);
        }

        return 70 * (l + h + u);
      },
      noise3D: function noise3D(t, e, i) {
        var r,
            a,
            n,
            o,
            c,
            l,
            h,
            u,
            f,
            p,
            d = this.permMod12,
            v = this.perm,
            b = this.grad3,
            y = (t + e + i) * (1 / 3),
            P = Math.floor(t + y),
            x = Math.floor(e + y),
            w = Math.floor(i + y),
            g = (P + x + w) * s,
            m = t - (P - g),
            k = e - (x - g),
            _ = i - (w - g);

        m >= k ? k >= _ ? (c = 1, l = 0, h = 0, u = 1, f = 1, p = 0) : m >= _ ? (c = 1, l = 0, h = 0, u = 1, f = 0, p = 1) : (c = 0, l = 0, h = 1, u = 1, f = 0, p = 1) : k < _ ? (c = 0, l = 0, h = 1, u = 0, f = 1, p = 1) : m < _ ? (c = 0, l = 1, h = 0, u = 0, f = 1, p = 1) : (c = 0, l = 1, h = 0, u = 1, f = 1, p = 0);
        var O = m - c + s,
            M = k - l + s,
            j = _ - h + s,
            C = m - u + 2 * s,
            I = k - f + 2 * s,
            S = _ - p + 2 * s,
            A = m - 1 + .5,
            R = k - 1 + .5,
            T = _ - 1 + .5,
            E = 255 & P,
            B = 255 & x,
            F = 255 & w,
            D = .6 - m * m - k * k - _ * _;
        if (D < 0) r = 0;else {
          var H = 3 * d[E + v[B + v[F]]];
          r = (D *= D) * D * (b[H] * m + b[H + 1] * k + b[H + 2] * _);
        }
        var U = .6 - O * O - M * M - j * j;
        if (U < 0) a = 0;else {
          var q = 3 * d[E + c + v[B + l + v[F + h]]];
          a = (U *= U) * U * (b[q] * O + b[q + 1] * M + b[q + 2] * j);
        }
        var L = .6 - C * C - I * I - S * S;
        if (L < 0) n = 0;else {
          var z = 3 * d[E + u + v[B + f + v[F + p]]];
          n = (L *= L) * L * (b[z] * C + b[z + 1] * I + b[z + 2] * S);
        }
        var G = .6 - A * A - R * R - T * T;
        if (G < 0) o = 0;else {
          var W = 3 * d[E + 1 + v[B + 1 + v[F + 1]]];
          o = (G *= G) * G * (b[W] * A + b[W + 1] * R + b[W + 2] * T);
        }
        return 32 * (r + a + n + o);
      },
      noise4D: function noise4D(t, e, i, r) {
        var a,
            n,
            s,
            l,
            h,
            u,
            f,
            p,
            d,
            v,
            b,
            y,
            P,
            x,
            w,
            g,
            m,
            k = this.perm,
            _ = this.grad4,
            O = (t + e + i + r) * o,
            M = Math.floor(t + O),
            j = Math.floor(e + O),
            C = Math.floor(i + O),
            I = Math.floor(r + O),
            S = (M + j + C + I) * c,
            A = t - (M - S),
            R = e - (j - S),
            T = i - (C - S),
            E = r - (I - S),
            B = 0,
            F = 0,
            D = 0,
            H = 0;
        A > R ? B++ : F++, A > T ? B++ : D++, A > E ? B++ : H++, R > T ? F++ : D++, R > E ? F++ : H++, T > E ? D++ : H++;
        var U = A - (u = B >= 3 ? 1 : 0) + c,
            q = R - (f = F >= 3 ? 1 : 0) + c,
            L = T - (p = D >= 3 ? 1 : 0) + c,
            z = E - (d = H >= 3 ? 1 : 0) + c,
            G = A - (v = B >= 2 ? 1 : 0) + 2 * c,
            W = R - (b = F >= 2 ? 1 : 0) + 2 * c,
            N = T - (y = D >= 2 ? 1 : 0) + 2 * c,
            J = E - (P = H >= 2 ? 1 : 0) + 2 * c,
            K = A - (x = B >= 1 ? 1 : 0) + 3 * c,
            Q = R - (w = F >= 1 ? 1 : 0) + 3 * c,
            V = T - (g = D >= 1 ? 1 : 0) + 3 * c,
            X = E - (m = H >= 1 ? 1 : 0) + 3 * c,
            Y = A - 1 + 4 * c,
            Z = R - 1 + 4 * c,
            $ = T - 1 + 4 * c,
            tt = E - 1 + 4 * c,
            et = 255 & M,
            it = 255 & j,
            rt = 255 & C,
            at = 255 & I,
            nt = .6 - A * A - R * R - T * T - E * E;
        if (nt < 0) a = 0;else {
          var st = k[et + k[it + k[rt + k[at]]]] % 32 * 4;
          a = (nt *= nt) * nt * (_[st] * A + _[st + 1] * R + _[st + 2] * T + _[st + 3] * E);
        }
        var ot = .6 - U * U - q * q - L * L - z * z;
        if (ot < 0) n = 0;else {
          var ct = k[et + u + k[it + f + k[rt + p + k[at + d]]]] % 32 * 4;
          n = (ot *= ot) * ot * (_[ct] * U + _[ct + 1] * q + _[ct + 2] * L + _[ct + 3] * z);
        }
        var lt = .6 - G * G - W * W - N * N - J * J;
        if (lt < 0) s = 0;else {
          var ht = k[et + v + k[it + b + k[rt + y + k[at + P]]]] % 32 * 4;
          s = (lt *= lt) * lt * (_[ht] * G + _[ht + 1] * W + _[ht + 2] * N + _[ht + 3] * J);
        }
        var ut = .6 - K * K - Q * Q - V * V - X * X;
        if (ut < 0) l = 0;else {
          var ft = k[et + x + k[it + w + k[rt + g + k[at + m]]]] % 32 * 4;
          l = (ut *= ut) * ut * (_[ft] * K + _[ft + 1] * Q + _[ft + 2] * V + _[ft + 3] * X);
        }
        var pt = .6 - Y * Y - Z * Z - $ * $ - tt * tt;
        if (pt < 0) h = 0;else {
          var dt = k[et + 1 + k[it + 1 + k[rt + 1 + k[at + 1]]]] % 32 * 4;
          h = (pt *= pt) * pt * (_[dt] * Y + _[dt + 1] * Z + _[dt + 2] * $ + _[dt + 3] * tt);
        }
        return 27 * (a + n + s + l + h);
      }
    }, l._buildPermutationTable = h, void 0 === (r = function () {
      return l;
    }.call(e, i, e, t)) || (t.exports = r), e.SimplexNoise = l, t.exports = l;
  }();
}, function (t, e, i) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.CanvasBackground = e.Pipeline = e.Coalesce = e.Aurora = e.Swirl = e.Shift = void 0;
  var r = l(i(5)),
      a = l(i(6)),
      n = l(i(7)),
      s = l(i(8)),
      o = l(i(9)),
      c = l(i(1));

  function l(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }

  e.Shift = r.default, e.Swirl = a.default, e.Aurora = n.default, e.Coalesce = s.default, e.Pipeline = o.default, e.CanvasBackground = c.default;
}, function (t, e, i) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var r = function () {
    function t(t, e) {
      for (var i = 0; i < e.length; i++) {
        var r = e[i];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, i, r) {
      return i && t(e.prototype, i), r && t(e, r), e;
    };
  }(),
      a = (o(i(0)), o(i(1))),
      n = o(i(3)),
      s = i(2);

  function o(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }

  var c = Math.cos,
      l = Math.sin,
      h = function (t) {
    function e(t) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var i = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      return i.circleProps = null, i.simplex = null, i.baseHue = null, i;
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, a.default), r(e, [{
      key: "init",
      value: function value() {
        this.initCircles();
      }
    }, {
      key: "draw",
      value: function value() {
        this.ctx.a.clearRect(0, 0, this.canvas.a.width, this.canvas.a.height), this.ctx.b.fillStyle = "hsla(0,0%,5%,1)", this.ctx.b.fillRect(0, 0, this.canvas.b.width, this.canvas.b.height), this.updateCircles(), this.renderShift();
      }
    }, {
      key: "initCircles",
      value: function value() {
        this.circleProps = new Float32Array(1200), this.simplex = new n.default(), this.baseHue = 220;
        var t = void 0;

        for (t = 0; t < 1200; t += 8) {
          this.initCircle(t);
        }
      }
    }, {
      key: "initCircle",
      value: function value(t) {
        var e, i, r, a, n, o, h, u, f, p;
        e = (0, s.rand)(this.canvas.a.width), i = (0, s.rand)(this.canvas.a.height), r = this.simplex.noise3D(.0015 * e, .0015 * i, .0015 * this.baseHue), a = (0, s.rand)(s.TAU), o = (n = .1 + (0, s.rand)(1)) * c(a), h = n * l(a), u = 150 + (0, s.rand)(200), f = 100 + (0, s.rand)(200), p = this.baseHue + 60 * r, this.circleProps.set([e, i, o, h, 0, u, f, p], t);
      }
    }, {
      key: "updateCircles",
      value: function value() {
        var t = void 0;

        for (this.baseHue++, t = 0; t < 1200; t += 8) {
          this.updateCircle(t);
        }
      }
    }, {
      key: "updateCircle",
      value: function value(t) {
        var e,
            i,
            r,
            a,
            n,
            s,
            o,
            c = 1 + t,
            l = 2 + t,
            h = 3 + t,
            u = 4 + t,
            f = 5 + t,
            p = 6 + t,
            d = 7 + t,
            v = void 0;
        e = this.circleProps[t], i = this.circleProps[c], r = this.circleProps[l], a = this.circleProps[h], v = this.circleProps[u], n = this.circleProps[f], s = this.circleProps[p], o = this.circleProps[d], this.drawCircle(e, i, v, n, s, o), v++, this.circleProps[t] = e + r, this.circleProps[c] = i + a, this.circleProps[u] = v, (this.checkBounds(e, i, s) || v > n) && this.initCircle(t);
      }
    }, {
      key: "drawCircle",
      value: function value(t, e, i, r, a, n) {
        this.ctx.a.save(), this.ctx.a.fillStyle = "hsla(" + n + ",60%,30%," + (0, s.fadeInOut)(i, r) + ")", this.ctx.a.beginPath(), this.ctx.a.arc(t, e, a, 0, s.TAU), this.ctx.a.fill(), this.ctx.a.closePath(), this.ctx.a.restore();
      }
    }, {
      key: "checkBounds",
      value: function value(t, e, i) {
        return t < -i || t > this.canvas.a.width + i || e < -i || e > this.canvas.a.height + i;
      }
    }, {
      key: "renderShift",
      value: function value() {
        this.ctx.b.save(), this.ctx.b.filter = "blur(50px)", this.ctx.b.drawImage(this.canvas.a, 0, 0), this.ctx.b.restore();
      }
    }]), e;
  }();

  e.default = h;
}, function (t, e, i) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var r = function () {
    function t(t, e) {
      for (var i = 0; i < e.length; i++) {
        var r = e[i];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, i, r) {
      return i && t(e.prototype, i), r && t(e, r), e;
    };
  }(),
      a = (o(i(0)), o(i(1))),
      n = o(i(3)),
      s = i(2);

  function o(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }

  var c = Math.cos,
      l = Math.sin,
      h = function (t) {
    function e(t) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var i = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      return i.tick = null, i.simplex = null, i.particleProps = null, i;
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, a.default), r(e, [{
      key: "init",
      value: function value() {
        this.initParticles();
      }
    }, {
      key: "draw",
      value: function value() {
        this.tick++, this.ctx.a.clearRect(0, 0, this.canvas.a.width, this.canvas.a.height), this.ctx.b.fillStyle = "hsla(260,40%,5%,1)", this.ctx.b.fillRect(0, 0, this.canvas.a.width, this.canvas.a.height), this.drawParticles(), this.renderGlow(), this.renderToScreen();
      }
    }, {
      key: "initParticles",
      value: function value() {
        this.tick = 0, this.simplex = new n.default(), this.particleProps = new Float32Array(6300);

        for (var t = 0; t < 6300; t += 9) {
          this.initParticle(t);
        }
      }
    }, {
      key: "initParticle",
      value: function value(t) {
        var e, i, r, a, n, o;
        e = (0, s.rand)(this.canvas.a.width), i = this.center[1] + (0, s.randRange)(100), r = 50 + (0, s.rand)(150), a = .1 + (0, s.rand)(2), n = 1 + (0, s.rand)(4), o = 220 + (0, s.rand)(100), this.particleProps.set([e, i, 0, 0, 0, r, a, n, o], t);
      }
    }, {
      key: "drawParticles",
      value: function value() {
        for (var t = 0; t < 6300; t += 9) {
          this.updateParticle(t);
        }
      }
    }, {
      key: "updateParticle",
      value: function value(t) {
        var e,
            i,
            r,
            a,
            n,
            o,
            h,
            u,
            f,
            p,
            d,
            v = 1 + t,
            b = 2 + t,
            y = 3 + t,
            P = 4 + t,
            x = 5 + t,
            w = 6 + t,
            g = 7 + t,
            m = 8 + t,
            k = void 0;
        i = this.particleProps[t], r = this.particleProps[v], e = 8 * this.simplex.noise3D(.00125 * i, .00125 * r, 5e-4 * this.tick) * s.TAU, a = (0, s.lerp)(this.particleProps[b], c(e), .5), n = (0, s.lerp)(this.particleProps[y], l(e), .5), k = this.particleProps[P], o = this.particleProps[x], u = i + a * (h = this.particleProps[w]), f = r + n * h, p = this.particleProps[g], d = this.particleProps[m], this.drawParticle(i, r, u, f, k, o, p, d), k++, this.particleProps[t] = u, this.particleProps[v] = f, this.particleProps[b] = a, this.particleProps[y] = n, this.particleProps[P] = k, (this.checkBounds(i, r) || k > o) && this.initParticle(t);
      }
    }, {
      key: "drawParticle",
      value: function value(t, e, i, r, a, n, o, c) {
        this.ctx.a.save(), this.ctx.a.lineCap = "round", this.ctx.a.lineWidth = o, this.ctx.a.strokeStyle = "hsla(" + c + ",100%,60%," + (0, s.fadeInOut)(a, n) + ")", this.ctx.a.beginPath(), this.ctx.a.moveTo(t, e), this.ctx.a.lineTo(i, r), this.ctx.a.stroke(), this.ctx.a.closePath(), this.ctx.a.restore();
      }
    }, {
      key: "checkBounds",
      value: function value(t, e) {
        return t > this.canvas.a.width || t < 0 || e > this.canvas.a.height || e < 0;
      }
    }, {
      key: "renderGlow",
      value: function value() {
        this.ctx.b.save(), this.ctx.b.filter = "blur(8px) brightness(200%)", this.ctx.b.globalCompositeOperation = "lighter", this.ctx.b.drawImage(this.canvas.a, 0, 0), this.ctx.b.restore(), this.ctx.b.save(), this.ctx.b.filter = "blur(4px) brightness(200%)", this.ctx.b.globalCompositeOperation = "lighter", this.ctx.b.drawImage(this.canvas.a, 0, 0), this.ctx.b.restore();
      }
    }, {
      key: "renderToScreen",
      value: function value() {
        this.ctx.b.save(), this.ctx.b.globalCompositeOperation = "lighter", this.ctx.b.drawImage(this.canvas.a, 0, 0), this.ctx.b.restore();
      }
    }]), e;
  }();

  e.default = h;
}, function (t, e, i) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var r = function () {
    function t(t, e) {
      for (var i = 0; i < e.length; i++) {
        var r = e[i];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, i, r) {
      return i && t(e.prototype, i), r && t(e, r), e;
    };
  }(),
      a = (o(i(0)), o(i(1))),
      n = o(i(3)),
      s = i(2);

  function o(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }

  var c = Math.round,
      l = function (t) {
    function e(t) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var i = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      return i.tick = null, i.simplex = null, i.rayProps = null, i;
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, a.default), r(e, [{
      key: "init",
      value: function value() {
        this.initRays();
      }
    }, {
      key: "draw",
      value: function value() {
        this.tick++, this.ctx.a.clearRect(0, 0, this.canvas.a.width, this.canvas.a.height), this.ctx.b.fillStyle = "hsla(220,60%,3%,1)", this.ctx.b.fillRect(0, 0, this.canvas.b.width, this.canvas.a.height), this.drawRays(), this.renderAurora();
      }
    }, {
      key: "initRays",
      value: function value() {
        this.tick = 0, this.simplex = new n.default(), this.rayProps = new Float32Array(4e3);

        for (var t = 0; t < 4e3; t += 8) {
          this.initRay(t);
        }
      }
    }, {
      key: "initRay",
      value: function value(t) {
        var e,
            i,
            r,
            a,
            n,
            o,
            l,
            h = void 0,
            u = void 0;
        e = 200 + (0, s.rand)(200), i = (0, s.rand)(this.canvas.a.width), h = this.center[1] + 100, u = this.center[1] + 100 - e, h += r = 100 * this.simplex.noise3D(.0015 * i, .0015 * h, .0015 * this.tick), u += r, a = 50 + (0, s.rand)(100), n = 10 + (0, s.rand)(20), o = .05 + (0, s.rand)(.1) * (c((0, s.rand)(1)) ? 1 : -1), l = 120 + (0, s.rand)(60), this.rayProps.set([i, h, u, 0, a, n, o, l], t);
      }
    }, {
      key: "drawRays",
      value: function value() {
        for (var t = 0; t < 4e3; t += 8) {
          this.updateRay(t);
        }
      }
    }, {
      key: "updateRay",
      value: function value(t) {
        var e,
            i,
            r,
            a,
            n,
            s,
            o = 1 + t,
            c = 2 + t,
            l = 3 + t,
            h = 4 + t,
            u = 5 + t,
            f = 6 + t,
            p = 7 + t,
            d = void 0,
            v = void 0;
        d = this.rayProps[t], e = this.rayProps[o], i = this.rayProps[c], v = this.rayProps[l], r = this.rayProps[h], a = this.rayProps[u], n = this.rayProps[f], s = this.rayProps[p], this.drawRay(d, e, i, v, r, a, s), d += n, v++, this.rayProps[t] = d, this.rayProps[l] = v, (this.checkBounds(d) || v > r) && this.initRay(t);
      }
    }, {
      key: "drawRay",
      value: function value(t, e, i, r, a, n, o) {
        var c = this.ctx.a.createLinearGradient(t, e, t, i);
        c.addColorStop(0, "hsla(" + o + ",100%,65%,0)"), c.addColorStop(.5, "hsla(" + o + ",100%,65%," + (0, s.fadeInOut)(r, a) + ")"), c.addColorStop(1, "hsla(" + o + ",100%,65%,0)"), this.ctx.a.save(), this.ctx.a.beginPath(), this.ctx.a.strokeStyle = c, this.ctx.a.lineWidth = n, this.ctx.a.moveTo(t, e), this.ctx.a.lineTo(t, i), this.ctx.a.stroke(), this.ctx.a.closePath(), this.ctx.a.restore();
      }
    }, {
      key: "checkBounds",
      value: function value(t) {
        return t < 0 || t > this.canvas.a.width;
      }
    }, {
      key: "renderAurora",
      value: function value() {
        this.ctx.b.save(), this.ctx.b.filter = "blur(12px)", this.ctx.a.globalCompositeOperation = "lighter", this.ctx.b.drawImage(this.canvas.a, 0, 0), this.ctx.b.restore();
      }
    }]), e;
  }();

  e.default = l;
}, function (t, e, i) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var r = function () {
    function t(t, e) {
      for (var i = 0; i < e.length; i++) {
        var r = e[i];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, i, r) {
      return i && t(e.prototype, i), r && t(e, r), e;
    };
  }(),
      a = (s(i(0)), s(i(1))),
      n = i(2);

  function s(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }

  var o = Math.cos,
      c = Math.sin,
      l = function (t) {
    function e(t) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var i = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      return i.tick = null, i.particleProps = null, i;
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, a.default), r(e, [{
      key: "init",
      value: function value() {
        this.initParticles();
      }
    }, {
      key: "draw",
      value: function value() {
        this.tick++, this.ctx.a.clearRect(0, 0, this.canvas.a.width, this.canvas.a.height), this.ctx.b.fillStyle = "hsla(60,50%,3%,1)", this.ctx.b.fillRect(0, 0, this.canvas.a.width, this.canvas.a.height), this.drawParticles(), this.renderGlow(), this.renderCoalesce();
      }
    }, {
      key: "initParticles",
      value: function value() {
        this.tick = 0, this.particleProps = new Float32Array(6300);

        for (var t = 0; t < 6300; t += 9) {
          this.initParticle(t);
        }
      }
    }, {
      key: "initParticle",
      value: function value(t) {
        var e, i, r, a, s, l, h, u, f;
        i = (0, n.rand)(this.canvas.a.width), r = (0, n.rand)(this.canvas.a.height), e = (0, n.angle)(i, r, this.center[0], this.center[1]), a = 6 * o(e), s = 6 * c(e), l = 100 + (0, n.rand)(500), h = .1 + (0, n.rand)(1), u = 2 + (0, n.rand)(10), f = 10 + (0, n.rand)(100), this.particleProps.set([i, r, a, s, 0, l, h, u, f], t);
      }
    }, {
      key: "drawParticles",
      value: function value() {
        for (var t = 0; t < 6300; t += 9) {
          this.updateParticle(t);
        }
      }
    }, {
      key: "updateParticle",
      value: function value(t) {
        var e,
            i,
            r,
            a,
            s,
            l,
            h,
            u,
            f,
            p,
            d,
            v = 1 + t,
            b = 2 + t,
            y = 3 + t,
            P = 4 + t,
            x = 5 + t,
            w = 6 + t,
            g = 7 + t,
            m = 8 + t,
            k = void 0;
        e = this.particleProps[t], i = this.particleProps[v], r = (0, n.angle)(e, i, this.center[0], this.center[1]) + .75 * n.HALF_PI, a = (0, n.lerp)(this.particleProps[b], 2 * o(r), .05), s = (0, n.lerp)(this.particleProps[y], 2 * c(r), .05), k = this.particleProps[P], l = this.particleProps[x], u = e + a * (h = this.particleProps[w]), f = i + s * h, p = this.particleProps[g], d = this.particleProps[m], this.drawParticle(e, i, r, k, l, p, d), k++, this.particleProps[t] = u, this.particleProps[v] = f, this.particleProps[b] = a, this.particleProps[y] = s, this.particleProps[P] = k, k > l && this.initParticle(t);
      }
    }, {
      key: "drawParticle",
      value: function value(t, e, i, r, a, s, o) {
        var c = t - .5 * s,
            l = e - .5 * s;
        this.ctx.a.save(), this.ctx.a.lineCap = "round", this.ctx.a.lineWidth = 1, this.ctx.a.strokeStyle = "hsla(" + o + ",100%,60%," + (0, n.fadeInOut)(r, a) + ")", this.ctx.a.beginPath(), this.ctx.a.translate(c, l), this.ctx.a.rotate(i), this.ctx.a.translate(-c, -l), this.ctx.a.strokeRect(c, l, s, s), this.ctx.a.closePath(), this.ctx.a.restore();
      }
    }, {
      key: "renderGlow",
      value: function value() {
        this.ctx.b.save(), this.ctx.b.filter = "blur(8px) brightness(200%)", this.ctx.b.globalCompositeOperation = "lighter", this.ctx.b.drawImage(this.canvas.a, 0, 0), this.ctx.b.restore(), this.ctx.b.save(), this.ctx.b.filter = "blur(4px) brightness(200%)", this.ctx.b.globalCompositeOperation = "lighter", this.ctx.b.drawImage(this.canvas.a, 0, 0), this.ctx.b.restore();
      }
    }, {
      key: "renderCoalesce",
      value: function value() {
        this.ctx.b.save(), this.ctx.b.globalCompositeOperation = "lighter", this.ctx.b.drawImage(this.canvas.a, 0, 0), this.ctx.b.restore();
      }
    }]), e;
  }();

  e.default = l;
}, function (t, e, i) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var r = function () {
    function t(t, e) {
      for (var i = 0; i < e.length; i++) {
        var r = e[i];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, i, r) {
      return i && t(e.prototype, i), r && t(e, r), e;
    };
  }(),
      a = (s(i(0)), s(i(1))),
      n = i(2);

  function s(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }

  var o = Math.cos,
      c = Math.sin,
      l = Math.round,
      h = 45 * n.TO_RAD,
      u = function (t) {
    function e(t) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var i = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      return i.tick = null, i.pipeProps = null, i;
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, a.default), r(e, [{
      key: "init",
      value: function value() {
        this.initPipes();
      }
    }, {
      key: "draw",
      value: function value() {
        this.updatePipes(), this.renderPipeline();
      }
    }, {
      key: "initPipes",
      value: function value() {
        this.pipeProps = new Float32Array(240);

        for (var t = 0; t < 240; t += 8) {
          this.initPipe(t);
        }
      }
    }, {
      key: "initPipe",
      value: function value(t) {
        var e, i, r, a, s, o, c;
        e = (0, n.rand)(this.canvas.a.width), i = this.center[1], r = l((0, n.rand)(1)) ? n.HALF_PI : n.TAU - n.HALF_PI, a = .5 + (0, n.rand)(1), s = 100 + (0, n.rand)(300), o = 2 + (0, n.rand)(4), c = 180 + (0, n.rand)(60), this.pipeProps.set([e, i, r, a, 0, s, o, c], t);
      }
    }, {
      key: "updatePipes",
      value: function value() {
        this.tick++;
        var t = void 0;

        for (t = 0; t < 240; t += 8) {
          this.updatePipe(t);
        }
      }
    }, {
      key: "updatePipe",
      value: function value(t) {
        var e,
            i,
            r,
            a,
            s,
            u,
            f = 1 + t,
            p = 2 + t,
            d = 3 + t,
            v = 4 + t,
            b = 5 + t,
            y = 6 + t,
            P = 7 + t,
            x = void 0,
            w = void 0,
            g = void 0,
            m = void 0;
        x = this.pipeProps[t], w = this.pipeProps[f], g = this.pipeProps[p], e = this.pipeProps[d], m = this.pipeProps[v], i = this.pipeProps[b], r = this.pipeProps[y], a = this.pipeProps[P], this.drawPipe(x, w, m, i, r, a), m++, x += o(g) * e, w += c(g) * e, s = !(this.tick % l((0, n.rand)(58)) || l(x) % 6 && l(w) % 6), u = l((0, n.rand)(1)) ? -1 : 1, g += s ? h * u : 0, this.pipeProps[t] = x, this.pipeProps[f] = w, this.pipeProps[p] = g, this.pipeProps[v] = m, this.checkBounds(x, w), m > i && this.initPipe(t);
      }
    }, {
      key: "drawPipe",
      value: function value(t, e, i, r, a, s) {
        this.ctx.a.save(), this.ctx.a.strokeStyle = "hsla(" + s + ",75%,50%," + .125 * (0, n.fadeInOut)(i, r) + ")", this.ctx.a.beginPath(), this.ctx.a.arc(t, e, a, 0, n.TAU), this.ctx.a.stroke(), this.ctx.a.closePath(), this.ctx.a.restore();
      }
    }, {
      key: "checkBounds",
      value: function value(t, e) {
        t > this.canvas.a.width && (t = 0), t < 0 && (t = this.canvas.a.width), e > this.canvas.a.height && (e = 0), e < 0 && (e = this.canvas.a.height);
      }
    }, {
      key: "renderPipeline",
      value: function value() {
        this.ctx.b.save(), this.ctx.b.fillStyle = "hsla(150,80%,1%,1)", this.ctx.b.fillRect(0, 0, this.canvas.b.width, this.canvas.b.height), this.ctx.b.restore(), this.ctx.b.save(), this.ctx.b.filter = "blur(12px)", this.ctx.b.drawImage(this.canvas.a, 0, 0), this.ctx.b.restore(), this.ctx.b.save(), this.ctx.b.drawImage(this.canvas.a, 0, 0), this.ctx.b.restore();
      }
    }]), e;
  }();

  e.default = u;
}]);